<script>
  import { onMount } from 'svelte';
  import { submit, validateInput, validateForm } from '../Form/utils.js';
  import ComboSelect from '../ComboSelect/ComboSelect.svelte';
  import DuplicateCheckTextInput from '../DuplicateCheckTextInput.svelte';
  import yup, { object, string, number } from 'yup';
  import Spinner from '../Spinner.svelte';
  import Errors from '../Errors.svelte';
  import TextInput from '../TextInput.svelte';
  import CheckBox from '../CheckBox.svelte';
  import {sgettext} from '../../i18n.js';

  import { control, controlOptions, iconOptions } from './store.js';

  export let duplicateCheckApi = '';
  export let actionUrl = '';
  export let editId = 0;
  export let onSubmit = (data) => data;
  // export let schema = null;
  export let fieldIsValid = {};
  export let show = false;

  let sending = false;
  let errors = null;
  let duplicateCheckHardFail = false;
  let controlNameBeforeEdit = '';

  let schema = object().shape({
    description: string().required(),
    name: string()
          .required()
          .test(
              sgettext("$$DUPLICATE_1$$"),
              sgettext("$$CONTROL_NAME_ALREADY_EXISTS$$"),
              _ => !duplicateCheckHardFail,
          ),
    icon_id: number()
      .required(sgettext('$$REQUIRED_FIELD$$'))
      .typeError(sgettext('$$REQUIRED_FIELD$$'))
  });

  export async function handleSubmit() {
    try {
      sending = true;
      const result = await validateForm(schema, $control);
      let method = 'POST';
      let url = actionUrl;
      if (editId) {
        method = 'PUT';
        url = actionUrl + editId + '/';
      }

      try {        
        const data = await submit(url, method, $control);
        resetForm();
        return data;
      } catch (err) {
        errors = err;
        return false;
      }
    } catch (err) {
      err.inner.forEach(er => {
        fieldIsValid[er.path].isValid = false;
        fieldIsValid[er.path].errors = er.message;
      })
    } finally {
      sending = false;
    }
  }

  export function resetForm(){
    control.set({
      description: '',
      icon_id: null
    })
    show = false;
  }

  function handleDuplicate(event) {
    duplicateCheckHardFail = false;
    if (event.detail.length) {
        if (event.detail[0].text !== controlNameBeforeEdit && event.detail[0].similarity === 100) {
            duplicateCheckHardFail = true;
        }
    }
  }

  onMount(() => {
    const descriptionInput = document.getElementById('description');

    if (descriptionInput) {
      descriptionInput.focus();
    }
  });
</script>

<style>
  .btn-link {
    width: fit-content;
    color: #656565;
    cursor: pointer;
  }

  .btn-link:focus {
    outline: none;
    color: #dd5900;
  }

  .btn-link:hover {
    color: #dd5900;
    text-decoration: none;
  }

  .container {
    padding: 15px;
    border: 1px solid #dee2e6;
  }
  header {
    margin-top: 15px;
    padding: 10px 15px;
    background-color: #dee2e6;
  }

  header h4 {
    margin: 0;
  }

  .inline-footer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .icon-spinner {
    margin-left: 15px;
  }
</style>

    <div class="form-group">
       <DuplicateCheckTextInput
        id="name"
        required="true"
        apiurl={duplicateCheckApi}
        label={sgettext("$$NAME_2$$")}
        message={sgettext("$$SIMILAR_CONTROL_FOUND$$")}
        bind:isValid={fieldIsValid.name.isValid}
        bind:errors={fieldIsValid.name.errors}
        bind:value={$control.name}
        on:check={handleDuplicate}
        {schema} />
    </div>

    <div class="form-group checkbox">
      <CheckBox
              id="confirmed"
              label={sgettext("$$PPE$$")}
              bind:checked={$control.ppe}
      />
    </div>

    <div class="form-group">
      <TextInput 
          id="description"
          label={sgettext("$$DESCRIPTION_1$$")}
          bind:isValid={fieldIsValid.description.isValid}
          bind:errors={fieldIsValid.description.errors}
          bind:value={$control.description}
          object={$control}
          {schema}
        />
    </div>

    <div class="form-row">
      <div class="form-group" style="width: 100%">
        <ComboSelect
          id="icon_id"
          label={sgettext("$$ICON_1$$")}
          options={$iconOptions}
          searchable={true}
          autoHeight={false}
          bind:isValid={fieldIsValid.icon_id.isValid}
          bind:errors={fieldIsValid.icon_id.errors}
          bind:value={$control.icon_id} />
      </div>

    </div>    
    <div class="inline-footer">
      {#if sending}
        <div class="icon-spinner">
          <Spinner size="small" />
        </div>
      {/if}
    </div>
    {#if errors}
    <Errors {errors} />
    {/if}
